import { BaseAdapter } from '@opus/web.core.lib.event-tracking/dist/adapters'
// import { AnonymousTrackingHelper } from '@utils'
import { httpRequestTracking } from '~/common/tracking/http.tracking'

class OpusTrackingAdapter extends BaseAdapter {
	logEvent(params) {
		const { type, payload, uiKey, componentName } = params

		const mergePayload = {
			...payload,
			ui_key: uiKey,
			component_name: componentName,
		}

		const mergeData = { ...mergePayload, ...this.basicInfo }
		const cusParams = {
			data: mergeData,
			name: type,
		}
		// if (authStore.isAnonymousLogin) {
		// 	AnonymousTrackingHelper.trackAnonymousClick(type, params)
		// }

		return httpRequestTracking.record(cusParams)
	}

	setUserId() {
		return new Promise(() => {})
	}

	setUserProperties() {
		return new Promise(() => {})
	}
	setBasicInfo(info) {
		this.basicInfo = info
	}
}

export { OpusTrackingAdapter }
